module.exports = __webpack_public_path__ + "img/faceb.a745ed62.png";